namespace TabAurous.ECommerce {
    export interface OrderProcessingForm {
    }

    export class OrderProcessingForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.OrderProcessing';
    }
}
